<template>
<div style="font-size: 0;">
    <top-head />
    <div class="section1">
        <img class="imgbg" src="../../../static/images/dynamic/section-1.jpg" />
        <img class="wrap" src="../../../static/images/dynamic/section-1-text.png"/>
    </div>
    <div class="section2">
        <img class="imgbg" src="../../../static/images/dynamic/section-2.jpg" />
        <h3>发展历程</h3>
    </div>
    <div class="section3">
        <!-- <ul>
            <template v-for="i in 21">
                <li v-if="i>=11" :key="i">
                    <img class="item-small" :src="getImgUrl('events/20'+i+'.png')" />
                    <img class="item-big" :src="getImgUrl('events/20'+i+'-B.png')" />
                </li>
            </template>
        </ul> -->
        <developHistory></developHistory>
    </div>
    <div class="section2">
        <img class="imgbg" src="../../../static/images/dynamic/section-2.jpg" />
        <h3>贝塔动态</h3>
    </div>
    <div class="section4">
        <img class="imgbg" src="../../../static/images/dynamic/section-4.jpg" />
        <ul>
            <li v-for="(o, index) in news" :key="index">
                <a target="_blank" :href="o.link">
                    <img :src="getImgUrl('news'+(index+1)+'.jpg')"/>
                    <div class="content">
                        {{ o.title }}<span>{{ o.date }}</span>
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <homeFoot />
</div>
</template>
<script>
import developHistory from '../parts/developHistory.vue'
import topHead from '../parts/headPart';
import homeFoot from '../parts/homeFoot.vue'
export default {
    name: 'introduce',
    components: {
        topHead,
        homeFoot,
        developHistory
    },
    data () {
        return {
            news: [
                { date: '2021-07-09', title: '贝塔新生代|校招训练营', link: 'https://mp.weixin.qq.com/s/B5Q0idPFG9LsMS7_k1Dhug' },
                { date: '2021-06-22', title: '贝塔迎来一大波儿拒绝躺平，对内卷say哒咩的年轻人，呱唧。', link: 'https://mp.weixin.qq.com/s/uf3psyzaLA5-J_6OKZfRIw' },
                { date: '2021-06-16', title: '连续上榜的第6个月 | 【中国厂商出海收入30强】', link: 'https://mp.weixin.qq.com/s?__biz=Mzg5NjU1NjU3OQ==&mid=2247483910&idx=1&sn=5c06f98839c4d105cfc6db7233bacb51&chksm=c07e094af709805ce93587bc6b9410a0c7c75c1ad84b8bf8411a8f18f68a3b5beb07f1023213&token=739679981&lang=zh_CN#rd' },
                { date: '2021-04-01', title: 'Supercell重金投资、国产代表月均流水1.6亿元，合成这个蓝海市场正待爆发', link: 'https://mp.weixin.qq.com/s?__biz=Mzg5NjU1NjU3OQ==&mid=2247483826&idx=1&sn=d6f1ed91d042f474132292e29f71c0c7&chksm=c07e0afef70983e8ae81aab3cbb84d12fa5a3ee6ccd9606a916c7d3834cd03cd5898989ca603&token=739679981&lang=zh_CN#rd' },
                { date: '2021-03-11', title: '第一期校招生围炉会完美收官', link: 'https://mp.weixin.qq.com/s?__biz=Mzg5NjU1NjU3OQ==&mid=2247483819&idx=1&sn=7b1ad8ec33d382ef8adfe3d5b99d736f&chksm=c07e0ae7f70983f1581f39a050bb94d732a481d8d084c2f3b7d6d12136842d983504278600e1&token=739679981&lang=zh_CN#rd' },
                // { date: '2021-02-01', title: '贝塔故事之金牌面试官篇丨人才也要，业绩也要，生活也要，我通通都要！！！', link: 'https://mp.weixin.qq.com/s?__biz=Mzg5NjU1NjU3OQ==&mid=2247483730&idx=1&sn=6bc673e69a383acd3de1344d20adc897&chksm=c07e0a1ef7098308dfa9863bf7f94fc322f207dfd5f9406557c00699a4764b70855eb252cd65&token=739679981&lang=zh_CN#rd' },
                { date: '2021-01-27', title: '贝塔科技做客中国教育电视台，分享创业创新历程及人才培养理念', link: 'https://mp.weixin.qq.com/s?__biz=Mzg5NjU1NjU3OQ==&mid=2247483695&idx=1&sn=8062e654bcb72f87b1a4c6ee09df4c05&chksm=c07e0a63f7098375105981ec0cd4c71f3987133bb5db51d98671aa1ba44b8551e838f6e3a66a&token=739679981&lang=zh_CN#rd' },
            ]
        }
    },
    methods: {
        getImgUrl (item) {
            return require('../../../static/images/dynamic/'+item);
        },
    }
}
</script>
<style scoped lang="less">
.center() {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.trans(@time){
    transition: @time;
   -webkit-transition: @time;
}
.imgbg {
    width: 100%;
}
.section1 {
    position: relative;
    .wrap {
        position: absolute;
        .center();
        transform: translate(-50%, 0);
        height: 57px;
    }
}
.section2 {
    position: relative;
    h3 {
        color: #fff;
        font-size: 36px;
        text-align: center;
        font-weight: 400;
        .center();
    }
}
.section3 {
    background: url('../../../static/images/dynamic/section-3.gif') no-repeat;
    background-size: cover;
    text-align: center;
    li {
        position: relative;
        padding: 50px 0;
        .trans(1s);
        .item-small {
            width: 864px;
            .trans(1s);
        }
        .item-big {
            position: absolute;
            right: -2000px;
            width: 1320px;
            top: 50%;
            .trans(1s);
            transform: translate(50%, -50%);
        }
        &:hover {
            background: #0C1947;
            .item-small {
                transform: translate(-2000px);
            }
            .item-big {
                right: 50%;
            }
        }
    }
}
.section4 {
    position: relative;
    a {
        display: block;
        color: #fff;
    }
    ul { 
        width: 1089px;
        .center();
    }
    li {
        display: inline-flex;
        margin: 10px 9px;
        width: 345px;
        background: #fff;
        img {
            width: 100%;
            height: 150px;
        }
    }
    .content {
        height: 103px;
        padding: 16px 10px;
        box-sizing: border-box;
        font-size: 18px;
        text-align: left;
        color: #4B4B4B;
        position: relative;
        line-height: 25px;
        span{
            font-size: 12px;
            color: #B5B5B5;
            line-height: 12px;
            position: absolute;
            left: 10px;
            bottom: 16px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dynamic.vue